import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { DYNAMIC_ISLAND } from "../../../config/dynamicIsland.configuration";

/** Haptic event kinds supported by the Dynamic Island shell. */
export type DynamicIslandHapticEvent = "open" | "close";

/**
 * Fires a light impact haptic when animations and platform allow it.
 * No-op on web, when haptics are disabled in config, or under reduced motion.
 *
 * @param event Open or close lifecycle event.
 * @param reducedMotion Whether the user prefers reduced motion.
 */
export async function triggerDynamicIslandHaptic(
    event: DynamicIslandHapticEvent,
    reducedMotion: boolean,
): Promise<void> {
    if ( reducedMotion || !DYNAMIC_ISLAND.animations.enabled || Capacitor.getPlatform() === "web" ) {
        return;
    }

    const { haptics } = DYNAMIC_ISLAND.animations;
    const shouldFire = event === "open" ? haptics.onOpen : haptics.onClose;

    if ( !shouldFire ) {
        return;
    }

    try {
        await Haptics.impact( { "style": ImpactStyle.Light } );
    } catch {
        // Haptics are best-effort; ignore unsupported platforms.
    }
}
